<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="loaderType.FILTER_PILL">
    <ng-container *ngIf="count > 0">
      <ngx-skeleton-loader
        [count]="count"
        appearance="line"
        class="filter-pill flex pt-3"
      />
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="loaderType.FILTER_INPUT">
    <ngx-skeleton-loader
      [count]="count"
      appearance="line"
      class="filter-input grid-col-{{columnCount}} grid-responsive-col-2 z-index-10 bg-color-white left-0"
    />
  </ng-container>
</ng-container>

